import cx from 'classnames';
import { getDiatonicChords, getChordQuality } from '../../utils/diatonicChords';

import './ScaleChords.scss';

/**
 * The seven diatonic chords of a key, in scale order.
 *
 * Selecting one is a toggle — the parent uses it to light the chord's tones on the
 * scale keyboard, and picking the same chord again clears the selection.
 */
const ScaleChords = ({ currentKey, activeChord = null, onSelect }) => {
  const chords = getDiatonicChords(currentKey);

  if (!chords.length) {
    return null;
  }

  return (
    <div className="scale-chords">
      {chords.map((chord) => {
        const isActive = activeChord === chord.name;
        const quality = getChordQuality(chord.name);
        const toggle = () => onSelect?.(isActive ? null : chord.name);

        return (
          <button
            key={chord.degree}
            type="button"
            aria-pressed={isActive}
            className={cx('scale-chords__chord', quality, { 'is-pressed': isActive })}
            title={`${chord.roman} — ${chord.name}`}
            // Latch on press, so the key is already held when :active lets go; a click would
            // land after release and the key would bounce up before dropping back down
            onPointerDown={(e) => e.button === 0 && toggle()}
            // Keyboard activation (Enter / Space) is the only click with no pointer press
            onClick={(e) => e.detail === 0 && toggle()}
          >
            {chord.name}
          </button>
        );
      })}
    </div>
  );
};

export default ScaleChords;
